<template>
  <!-- The checkmark sits 3px outside each badge's top-right corner, so the
       container needs right/top breathing room or AG-Grid clips the last one. -->
  <div
    class="flex flex-wrap items-start gap-1.5"
    style="align-content: flex-start; padding: 6px 8px 4px 0; overflow: visible;"
  >
    <span
      v-for="code in measureCodes"
      :key="code"
      class="relative inline-flex items-center justify-center rounded-full text-[10px] font-semibold leading-none whitespace-nowrap"
      :class="badgeClass(code)"
      :title="badgeTitle(code)"
      style="min-width: 20px; height: 20px; padding: 0 5px;"
    >{{ shortCode(code) }}<!--
      --><span
        v-if="isPotentiallyClosed(code)"
        class="absolute flex items-center justify-center rounded-full
               bg-green-500 text-white ring-1 ring-white"
        style="width: 10px; height: 10px; font-size: 7px; line-height: 1;
               top: -3px; right: -3px;"
      >✓</span>
    </span>
  </div>
</template>

<script>
// Color palette: deterministic by first letter group so related measures share hues
const CODE_COLORS = {
  'A': 'bg-blue-100 text-blue-700',
  'B': 'bg-pink-100 text-pink-700',
  'C': 'bg-purple-100 text-purple-700',
  'D': 'bg-amber-100 text-amber-700',
  'E': 'bg-teal-100 text-teal-700',
  'F': 'bg-orange-100 text-orange-700',
  'G': 'bg-emerald-100 text-emerald-700',
  'H': 'bg-red-100 text-red-700',
  'I': 'bg-indigo-100 text-indigo-700',
  'K': 'bg-cyan-100 text-cyan-700',
  'L': 'bg-lime-100 text-lime-700',
  'M': 'bg-violet-100 text-violet-700',
  'O': 'bg-rose-100 text-rose-700',
  'P': 'bg-sky-100 text-sky-700',
  'S': 'bg-fuchsia-100 text-fuchsia-700',
  'T': 'bg-stone-200 text-stone-700',
  'W': 'bg-yellow-100 text-yellow-700',
};
const DEFAULT_COLOR = 'bg-gray-100 text-gray-700';

export default {
  name: 'Quality_GapCountCell',
  props: ['params'],
  computed: {
    measureCodes() {
      return this.params.data?.measure_codes || [];
    },
    /**
     * Measures whose logged MRR work is expected to close the gap
     * (gap_status = 'potentially_closed' from the work translators).
     */
    potentiallyClosed() {
      return new Set(this.params.data?.potentially_closed_measures || []);
    }
  },
  methods: {
    shortCode(code) {
      // Strip -E suffix for display brevity (BCS-E → BCS, COL-E → COL)
      return code.replace(/-E$/, '');
    },
    badgeClass(code) {
      const firstChar = code.charAt(0).toUpperCase();
      return CODE_COLORS[firstChar] || DEFAULT_COLOR;
    },
    isPotentiallyClosed(code) {
      return this.potentiallyClosed.has(code);
    },
    badgeTitle(code) {
      return this.isPotentiallyClosed(code)
        ? `${code} — potentially closed (closure evidence logged)`
        : code;
    }
  }
};
</script>
